export default "./dist/stdassets/images/icons/icon_menuarrowup_disabled.png";